<template>
  <div class="row">
    <div class="col-md-12 header">
      <div class="row p-4">
        <!-- <div class="col-md-3 col-sm-2 offset-md-1 mt-4">
          <selector id="category-sel" name="category-sel" mandatory="false" placeholder="Category" :data="categories" valuefield="category_id" textfield="category_name" inlinerows="false" classes="bg-gray" ref="categorySelector" v-model="selectedCategory" @change="filterCourses"></selector>
        </div> -->
        <div class="col-md-3" v-if="!isShowingCourseItemPreview">
          <selector id="type-sel" name="type-sel" mandatory="false" :placeholder="$t(LangConstants.type_placeholder)" :data="types" valuefield="type_id" textfield="type_name" inlinerows="false" classes="bg-gray" blockClasses="" blockLabelClass="col-md-12 pl-0 pr-0" ref="typeSelector" v-model="selectedType" @change="filterCourses"></selector>
        </div>

        <div class="col-auto ml-auto pr-0" v-if="isShowingCourseItemPreview && woocommerceIntegration == 0">
          <my-button fa="reply" fapos="left" :label="$t(LangConstants.go_back_button_label)" variant="solid-primary" classes="pl-4 pr-4" height="48px" @onClick="handleBackBtn"></my-button>
        </div>
      </div>
    </div>

    <div class="col-md-12 courses-container" v-if="!isShowingCourseItemPreview">
      <div class="row form-base">
        <div class="col-md-4 mb-3" v-for="course in visibleWebshopItems" :key="course.id" id="courses-list">
          <shop-course-item :id="course.id" :title="course.courseInstance.name" :price="course.price" :image="course.courseInstance.image ? course.courseInstance.image : defaultImage" :link="course.courseid" :currency="course.currency" @click="showCourseItemPreview(course.courseid, course.instance_id)" />
        </div>
      </div>

      <no-data-box v-if="visibleWebshopItems != null && visibleWebshopItems.length == 0">
        <h5 class="mb-0">
          {{ $t(LangConstants.shop_preview_no_courses) }}
        </h5>
      </no-data-box>

      <discount :enabled="enableSetDiscount"> </discount>

      <div class="row mt-4" v-if="visibleWebshopItems.length != 0">
        <div class="mx-auto">
          <pagination :rows="contentLength" :perPage="itemsPerPage" class="" ariacontrols="courses-list" @change="handlePageChange" align="center" :currentPage="currentPage" />
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row">
        <shop-course-item-preview :course="showingCourseX" v-if="isShowingCourseItemPreview" @navigate="hideShopCoursePreview" :isPreview="isPreview" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  background-color: #476570;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.courses-container {
  // background: var(--white);
  padding-top: 1px;
}
</style>

<script>
import ShopCourseItem from "./ShopCourseItem.vue";
import ShopCourseItemPreview from "./ShopCourseItemPreview.vue";
import Pagination from "../atoms/Pagination.vue";
import Selector from "../atoms/Selector.vue";
import MyButton from "../atoms/Button.vue";
import Common from "../../functions/index";
import NoDataBox from "../atoms/NoDataBox.vue";
import Discount from "./Discount.vue";
import Constants from "../../constants/index";

export default {
  name: "shop-preview",

  data: function() {
    return {
      selectedType: 0,
      currentPage: 1,
      itemsPerPage: 6,
      contentLength: 0,
      isShowingCourseItemPreview: false,
      showingCourse: {},

      // categories:[
      //   {category_id:1, category_name:"Cat 1"},
      //   {category_id:2, category_name:"Cat 2"},
      //   {category_id:3, category_name:"Cat 3"}
      // ],

      filteredCourses: [],
    };
  },
  props: {
    webshop: {
      required: true,
    },
    enableSetDiscount: {
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    defaultPrviewCourse: {
      default: 0,
    },
    instanceId: {
      default: 0,
    },
  },

  setup() {},

  beforeCreate() {
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    eventer(
      messageEvent,
      function() {
        //  this.sendHeight();
      },
      false
    );
  },
  created() {
    this.splitContent(this.courses);
    this.contentLength = this.courses.length;
  },
  mounted() {
    if (this.courses.length > 0 && this.defaultPrviewCourse > 0) {
      this.showCourseItemPreview(this.defaultPrviewCourse, this.instanceId);
    }
    this.sendHeight();
  },
  updated() {
    this.sendHeight();
  },
  methods: {
    sendHeight() {
      if (parent.postMessage) {
        var element = document.getElementById("websop-public-container");
        if (element != null) {
          parent.postMessage(element.offsetHeight, "*");
        }
      }
    },
    filterCourses() {
      this.filteredCourses = this.selectedType == "0" ? this.courses : this.courses.filter((course) => course.courseInstance.type == this.selectedType);
      this.contentLength = this.filteredCourses.length;
      this.splitContent(this.filteredCourses);
    },

    handlePageChange(page) {
      this.currentPage = page;
      if (this.selectedType == 0) {
        this.splitContent(this.courses);
      } else {
        this.splitContent(this.filteredCourses);
      }
    },

    splitContent(content) {
      this.filteredCourses = content.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage);
    },

    showCourseItemPreview(courseId, instanceId) {
      this.showingCourse = this.courses.find((course) => course.courseid == courseId && course.instance_id == instanceId);
      this.isShowingCourseItemPreview = true;
    },

    hideShopCoursePreview(href) {
      if (href == "back") {
        this.showingCourse = {};
        this.isShowingCourseItemPreview = false;
      }
    },

    handleBackBtn() {
      this.isShowingCourseItemPreview = false;
    },
  },

  computed: {
    woocommerceIntegration() {
      const settings = this.$store.getters.generalSettings;
      if (settings != null && settings.instanceSettings.woocommerce_integration == 1) {
        return true;
      }
      return false;
    },
    showingCourseX() {
      return this.showingCourse;
    },
    //     itemsPerPage(){
    //   const authUser = this.$store.getters.getAuthUser;
    //   return Common.isCustomerSettingEnabled(authUser, 'items_per_page');
    // },
    courses() {
      return this.$props.webshop; //.filter((item) => item.webshop == true);
    },
    webShopItems() {
      return this.$props.webshop.filter((item) => item.webshop == true);
    },
    visibleWebshopItems() {
      return this.filteredCourses.filter((item) => item.webshop == true);
    },
    defaultImage() {
      return Common.getImagefromContext("placeholder");
    },

    types() {
      return this.$store.getters.courseTypes;
    },

    LangConstants() {
      return Constants;
    },
  },

  watch: {
    webshop1: {
      immediate: true,
      handler() {
        this.splitContent(this.courses);
        this.filterCourses();
      },
    },

  webshop: {
    immediate: true,
    deep: true,
    handler(newVal) {
      // Sync filtered list
      this.filterCourses();

      // Set preview course only if applicable and found
      if (this.defaultPrviewCourse && this.instanceId && !this.isShowingCourseItemPreview) {
        const course = newVal.find(c => c.courseid == this.defaultPrviewCourse && c.instance_id == this.instanceId);
        if (course) {
          this.showingCourse = JSON.parse(JSON.stringify(course)); // force reactivity
          this.isShowingCourseItemPreview = true;
        }
      }
    }
  
}

  },

  components: {
    ShopCourseItem,
    Selector,
    Pagination,
    ShopCourseItemPreview,
    MyButton,
    NoDataBox,
    Discount,
  },
};
</script>
